
export function compareStrings(a, b) {
  if (a > b) {
    return 1;
  }
  else if (a < b) {
    return -1;
  }
  else {
    return 0;
  }
}

// items should be {betting: {current_odds}}
export function sortByOdds(...items) {
  const [a, b] = items
    .map(({betting: {current_odds} = {}}) => {
      if (!current_odds) {
        return Number.MAX_VALUE;
      }

      const [numerator, denominator] = current_odds.split('/').map(o => parseInt(o, 10));
      if (numerator && denominator) {
        return numerator / denominator;
      } else {
        return Number.MAX_VALUE;
      }
    });

  return a - b;
}

// items should be {horse: {name}}
export function sortByHorseName(...items) {
  return compareStrings(...items.map(({horse: {name} = {}}) => name));
}

// items should be {cloth_number}
export function sortByClothNumber(...items) {
  const [
    {
      cloth_number: a = Number.MAX_VALUE
    } = {},
    {
      cloth_number: b = Number.MAX_VALUE
    } = {}
  ] = items;

  return (a - b);
}




// WEBPACK FOOTER //
// ./utils/compare.js